import Buy5ExtraHolidaysIcon from '../assets/icons/Buy_5_Days_Holidays.svg'
import CompanyPensionIcon from '../assets/icons/Company_pension.svg'
import CycleToWorkIcon from '../assets/icons/Cycle_Work_Scheme.svg'
import ExtraHolidayIcon from '../assets/icons/Extra_Holiday.svg'
import FirstBoxFreeIcon from '../assets/icons/First_Gousto_Box_Free.svg'
import FreeCoffeeIcon from '../assets/icons/Free_Coffee.svg'
import FriendsFamilyDiscountIcon from '../assets/icons/Friends_Family_Discount.svg'
import Gousto40DiscountIcon from '../assets/icons/Gousto_Discount.svg'
import GoustoStashIcon from '../assets/icons/Gousto_Stash.svg'
import GymIcon from '../assets/icons/Gym.svg'
import HealthcareIcon from '../assets/icons/Healthcare.svg'
import Holidays25daysIcon from '../assets/icons/25_Days_Holiday.svg'
import ReferralSchemeIcon from '../assets/icons/Referral_scheme.svg'
import TeamSocialsIcon from '../assets/icons/Team_Socials.svg'

const BENEFITS = [
  {
    description: '25 days holiday \n(plus bank holidays)',
    icon: Holidays25daysIcon,
  },
  {
    description: 'A holiday day added each year \n(up to 30 days)',
    icon: ExtraHolidayIcon,
  },
  {
    description: 'Buy up to 5 days extra holiday',
    icon: Buy5ExtraHolidaysIcon,
  },
  {
    description: '40% Gousto discount',
    icon: Gousto40DiscountIcon,
  },
  {
    description: 'Your first Gousto box FREE',
    icon: FirstBoxFreeIcon,
  },
  {
    description: '15% Gousto discount for friends and family',
    icon: FriendsFamilyDiscountIcon,
  },
  {
    description: 'Private healthcare',
    icon: HealthcareIcon,
  },
  {
    description: 'Gym and ClassPass membership',
    icon: GymIcon,
  },
  {
    description: 'Cycle to work scheme',
    icon: CycleToWorkIcon,
  },
  {
    description: 'Referral scheme',
    icon: ReferralSchemeIcon,
  },
  {
    description: 'Company pension',
    icon: CompanyPensionIcon,
  },
  {
    description: 'Regular team socials and mixed team events',
    icon: TeamSocialsIcon,
  },
  {
    description: 'Gousto stash - hoodie, notepad, mug',
    icon: GoustoStashIcon,
  },
  {
    description: 'Free coffee, tea, fruit and ice cream',
    icon: FreeCoffeeIcon,
  },
]

export { BENEFITS }
